"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.useToggle = function (initialValue) {
    var _a = React.useState(initialValue || false), value = _a[0], setValue = _a[1];
    var toggle = function (target) {
        if (target !== undefined) {
            setValue(target);
        }
        else {
            setValue(function (previous) { return !previous; });
        }
    };
    return [value, toggle];
};
//# sourceMappingURL=index.js.map